import gsap from 'gsap'

// const DEFAULT_EASING = 'power4.out'

export default {
  setSplit: ({ $chars }) => {
    gsap.set($chars, { opacity: 0, y: '100%' })
  },
  setLinear: ({ $chars }) => {
    gsap.set($chars, { opacity: 0, y: '120%', scaleY: 2 })
  },
  splitAppear: ({ $first, delay, duration, complete }) => {
    const timeline = gsap.timeline({ paused: true, delay })
    timeline
      .to($first, {
        opacity: 1,
        y: '0%',
        stagger: (index, el) => (el.parentNode.children.length - index - 1) * 0.04,
        ease: 'power3.inOut',
        duration,
        complete,
      })
    return timeline
  },
  splitHover: ({ $first, $second, delay }) => {
    const timeline = gsap.timeline({ paused: true, delay })
    timeline
      .to($first, {
        opacity: 0,
        y: '-100%',
        stagger: (index, el) => (el.parentNode.children.length - index - 1) * 0.02,
        ease: 'power1.out',
      })
      .to($second, {
        opacity: 1,
        y: '0%',
        stagger: (index, el) => (el.parentNode.children.length - index - 1) * 0.02,
        ease: 'power1.inOut',
      }, '<-0.05')
    return timeline
  },
  linearHover: ({ $first, $second, delay }) => {
    const timeline = gsap.timeline({ paused: true, delay })
    timeline
      .to($first, {
        opacity: 0,
        y: '-100%',
        ease: 'power3.out',
        duration: 0.7,
      })
      .to($second, {
        opacity: 1,
        y: '0%',
        ease: 'power3.inOut',
        duration: 0.7,
      }, '<-0.2')
    return timeline
  },
  linearAppear: ({ $first, delay, duration, complete }) => {
    const timeline = gsap.timeline({ paused: true, delay })
    timeline
      .to($first, {
        opacity: 1,
        y: '0%',
        scaleY: 1,
        ease: 'expo.out',
        duration,
        complete,
      })
    return timeline
  },
}
